
export const formatToDisplayDateYY = (date: Date, options: Intl.DateTimeFormatOptions | undefined = { year: '2-digit', month: '2-digit', day: '2-digit' })
: string => new Intl.DateTimeFormat('en-GB', options).format(date);

export const formatToDisplayDateYYYY = (date: Date, options: Intl.DateTimeFormatOptions | undefined = { year: 'numeric', month: '2-digit', day: '2-digit' })
: string => new Intl.DateTimeFormat('en-GB', options).format(date);